<ng-container *ngIf="model">
  <p class="annotation">
    {{ model.text }}
  </p>
  <result-rich-text-section-elements
    [items]="items"
    [highlights]="highlights"
    (click)="onInvoke()"
  ></result-rich-text-section-elements>
</ng-container>
